// OP Widget URL
import { env } from 'next-runtime-env';

export const getWidgetUrl = () => `${env('NEXT_PUBLIC_BASE_URL')}/widgets/op-calc-assets`;

// OP Calculator link
export const OPLink = 'https://eficode.pohjola-finance.fi/tililuotto-uusi/huutokaupat';

export const OpCalculatorConfig = {
  linkCta: OPLink,
  linkMore: 'https://huutokaupat.com/rahoitus',
  heading: 'Rahoituksen määrä',
  colorPrimary: '#3485d7',
  colorSecondary: '#ffffff',
  textOpenBtn: 'Maksa erissä',
  percentage: [0.012, 0.017, 0.021],
  enableInputChanges: true,
  showInput: true,
  showCta: true,
  showInfo: {
    realInterest: false,
    interestMargin: true,
    paybackTime: true,
    costEstimate: true,
  },
  texts: {
    ctaButton: 'Tutustu ja hae',
    inputAmountLabel: 'Rahoituksen määrä',
    teaser:
      'Varaudu hinnan nousuun hakemalla riittävää määrää - kaikkea ei tarvitse käyttää tämän kohteen maksamiseen. Maksa takaisin 1 kk päästä toimituksesta ilman korkoja ja kuluja tai lyhennä sopivalla kuukausierällä:',
    floating: {
      openButton: 'Maksa erissä',
    },
    product: {
      openButtonTextStart: 'Tai',
      openButtonTextEnd: 'rahoituksella',
    },
  },
};

export type OpCalculatorConfigType = typeof OpCalculatorConfig;
interface OpCalculatorProductConfig extends OpCalculatorConfigType {
  initAmount?: number;
  initAmountMin?: number;
  type: 'product';
}
export interface OpCalculatorOptionsType {
  product: OpCalculatorProductConfig;
}

export type CalculatorType = keyof OpCalculatorOptionsType;

interface OpLaskuriScriptProps {
  calculatorType?: CalculatorType;
  loanAmount: number;
  loanAmountMin: number;
}

/* eslint-disable no-underscore-dangle */
export const clearOpLaskuriOptions = () => {
  window.__opCalcAccount = undefined;
  window.__opCalcOpts = undefined;
  window.__opCalcWidget = undefined;
};

export const setOpLaskuriOptions = ({
  calculatorType = 'product',
  loanAmount,
  loanAmountMin,
}: OpLaskuriScriptProps) => {
  window.__opCalcAccount = window.__opCalcAccount
    ? window.__opCalcAccount
    : { mode: 'tililuotto-uusi', key: 'huutokaupat' };
  if (!window.__opCalcOpts) {
    window.__opCalcOpts = {
      [`${calculatorType}` as CalculatorType]: {
        ...OpCalculatorConfig,
        initAmount: loanAmount,
        initAmountMin: loanAmountMin,
        type: calculatorType,
      },
    };
  }
};
/* eslint-enable no-underscore-dangle */
